import { setSelectedAddress } from "../slice";
import { checkConnectionAndTariffs } from "./checkConnectionAndTariffs";
export var initAddressAndRunVerification = function initAddressAndRunVerification(address) {
  return function (dispatch) {
    dispatch(setSelectedAddress(address));
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    dispatch(checkConnectionAndTariffs());
  };
};